import React from 'react'

const snackBarContext = React.createContext({
    snackBarOpen: false,
    snackBarMessage: "",
    setSnackBarOpen: () => {},
    setSnackBarMessage: () => {},
})

export default snackBarContext;